export const TAG_TYPES = {
  RECRUIT_ASSIGNMENT: 'recruit_assignment',
  RECRUIT_PROGRESS: 'recruit_progress',
} as const;
